import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Icon from "basic-elements/Icon";
import styles from "./HeaderDropdown.module.scss";

const HeaderDropdown = props => (
  <div className={classnames(styles.dropdown, props.className)}>
    <div className={styles.dropdown__trigger}>
      {props.title}
      <Icon name="arrow-down" className={styles.dropdown__icon} />
    </div>
    <div className={styles.dropdown__menu} data-role="menu">
      {props.children}
    </div>
  </div>
);

HeaderDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  className: PropTypes.string
};

export default HeaderDropdown;
